import { Enums, type Types } from '@cornerstonejs/core';
import { createSynchronizer } from '../../store/SynchronizerManager';
import presentationViewSyncCallback from '../callbacks/presentationViewSyncCallback';
import type Synchronizer from '../../store/SynchronizerManager/Synchronizer';
import type { ISynchronizerEventHandler } from '../../types';

const { CAMERA_MODIFIED } = Enums.Events;

/**
 * A helper that creates a new `Synchronizer` which listens to the `CAMERA_MODIFIED`
 * rendering event and calls the `cameraSyncCallback` based on presentation view
 * values and not based on absolute camera positions.
 *
 * @param synchronizerName - The name of the synchronizer.
 * @returns A new `Synchronizer` instance.
 */
export default function createPresentationViewSynchronizer(
  synchronizerName: string,
  options?: Types.ViewPresentationSelector
): Synchronizer {
  const presentationView = createSynchronizer(
    synchronizerName,
    CAMERA_MODIFIED,
    presentationViewSyncCallback as ISynchronizerEventHandler,
    { viewPresentation: options }
  );

  return presentationView;
}
